'use client';

import { useState } from 'react';

interface Props {
  id: string;
  name: string;
  width: number;
  height: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function BeneficialImage({ id, name, width, height, className = '', style }: Props) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className={className}
        style={{ width, height, background: '#ffffff', ...style }}
        aria-label={name}
      />
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={`/images/beneficials/${id}.png`}
      alt={name}
      width={width}
      height={height}
      loading="lazy"
      onError={() => setErrored(true)}
      className={className}
      style={{ objectFit: 'cover', ...style }}
    />
  );
}
